import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, NgForm, FormControl } from '@angular/forms';
import { contactUsDTO, emailNotificationDTO, notificationType, organizationDTO, printRequestDTO } from 'src/app/models/providersDTO';
import { Alert } from 'selenium-webdriver';
import { ResultsService } from 'src/app/services/results.service';
import { PersistenceService, StorageType } from 'angular-persistence';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  
  constructor(private router: Router, private formBuilder: FormBuilder, private resultservice: ResultsService, private persistenceService: PersistenceService) { }

  contactusform: FormGroup;
  contactusSubmitform: FormGroup;
  User:FormControl; 
  submitted: boolean = false;
  public orgDetails: organizationDTO = new organizationDTO();
  CurrentDate:any = new Date();
  ServerDateTime =  formatDate(this.CurrentDate, 'MM/dd/yyyy hh:mm a', 'en-US', '-0500');
  webSiteUrl=localStorage.getItem("WebsiteUrl");
  portallogo:any= this.webSiteUrl+"assets/content/default/images/PortalLogo.png"
  facebookicon:any = this.webSiteUrl+"assets/content/default/images/facebook.png"
  linkedinicon:any = this.webSiteUrl+"assets/content/default/images/linkedin.png"
  twittericon:any = this.webSiteUrl+"assets/content/default/images/twitter.png"
  instagramicon:any=this.webSiteUrl+"assets/content/default/images/instagram.png"
  youtubeicon:any = this.webSiteUrl+"assets/content/default/images/youtube.png"
  ngOnInit() {
    this.contactusform = this.formBuilder.group({
      //firstname: [this.formControl.firstname.value ||'', [Validators.required,this.noWhitespaceValidator]],
      firstname:['',[Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,-_\sa-z0-9 ]+)*$/i)]],
      lastname: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,-_\sa-z0-9 ]+)*$/i)]],
      phonename: ['', [Validators.required, Validators.pattern(/^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]],
      subject: ['', Validators.required],
      message: ['', [Validators.required, Validators.pattern(/[-_\s]{0}^[a-z0-9]+([.,#-_\sa-z0-9]+)*$/i)]],
      
    }); 

  }
  
  onSubmit() {
    this.submitted = true;
    debugger;

    // this.contactusSubmitform = this.formBuilder.group({
    //   firstname:[this.formControl.firstName.value || '',[Validators.required, this.noWhitespaceValidator]]
    // });

    if (this.contactusform.invalid) {
      return;
    }
    else {
      var contactus = new contactUsDTO();
      var printRequest = new printRequestDTO();
      //user = this.adduser.value;
      contactus.firstName = this.formControl.firstname.value.trim();
      contactus.lastName = this.formControl.lastname.value;
      contactus.phone = this.formControl.phonename.value;
      contactus.email = this.formControl.email.value;
      contactus.subject = this.formControl.subject.value;
      contactus.Notes = this.formControl.message.value;
      this.resultservice.SaveContactUsDetails(contactus).then((result: any) => {
        debugger;
        if (result == 1) {
          var emailNotificationAcknow = new emailNotificationDTO();
          var emailNotificationReport = new emailNotificationDTO();
          var location="<a href='"+this.webSiteUrl+"'>website</a>";
          this.resultservice.GetNotificationsContent(notificationType.ContactUsAcknowledgement.toString()).then((result: any) => {
            emailNotificationAcknow.To = contactus.email;
            // if (result[0].toEmail != undefined && result[0].toEmail != null && result[0].toEmail != '') {
            //   emailNotification.To = contactus.email + "," + result[0].toEmail;
            // }
            // else
            // {
            //   emailNotification.To = contactus.email;
            // }
            if (result[0].ccEmail != undefined && result[0].ccEmail != null && result[0].ccEmail != '') {
              emailNotificationAcknow.Cc =  result[0].ccEmail;
            }
            if (result[0].toEmail != undefined && result[0].toEmail != null && result[0].toEmail != '') {
              emailNotificationAcknow.Bcc =  result[0].toEmail;
            }
            emailNotificationAcknow.Subject = result[0].subjectLine;

            var bodycontent = result[0].bodyContent;

            this.orgDetails = this.persistenceService.get('currentorgDetails', StorageType.SESSION);
            bodycontent = bodycontent.split('[[FirstName]]').join(contactus.firstName)
            .split('[[LastName]]').join(contactus.lastName)
              .split('[[CHP]]').join(this.orgDetails.orgName).split('[[SupportMessage]]').join("Support Team")
              .split('[[CHPPhone]]').join(this.orgDetails.orgPhone)
              .split('[[CHPEmail]]').join(this.orgDetails.orgEmail).split('[[PortalUrl]]').join(location)
              .split('[[CurrentDate]]').join(this.ServerDateTime)
              .split('[[FacebookLink]]').join(this.orgDetails.facebookLink)
              .split('[[LinkedinLink]]').join(this.orgDetails.linkedInLink)
              .split('[[TwitterLink]]').join(this.orgDetails.twitterLink)
              .split('[[InstagramLink]]').join(this.orgDetails.instagramLink)
              .split('[[YoutubeLink]]').join(this.orgDetails.youtubeLink)
              .split('[[portallogo]]').join(this.portallogo)
              .split('[[facebookicon]]').join(this.facebookicon)
              .split('[[linkedinicon]]').join(this.linkedinicon)
              .split('[[twittericon]]').join(this.twittericon)
              .split('[[instagramicon]]').join(this.instagramicon)
              .split('[[youtubeicon]]').join(this.youtubeicon)
              emailNotificationAcknow.Content = bodycontent;
            this.resultservice.SendEmailNotification(emailNotificationAcknow).then((result: any) => {

              //this.router.navigate(['']);
            })

          })
          this.resultservice.GetNotificationsContent(notificationType.ContactUsReport.toString()).then((response: any) => {
            debugger;
            emailNotificationReport.To = response[0].toEmail;
            if (response[0].ccEmail != undefined && response[0].ccEmail != null && response[0].ccEmail != '') {
              emailNotificationReport.Cc =  response[0].ccEmail;
            }
            emailNotificationReport.Subject = response[0].subjectLine;

            var bodycontent = response[0].bodyContent;
            

            this.orgDetails = this.persistenceService.get('currentorgDetails', StorageType.SESSION);
            bodycontent = bodycontent.split('[[FirstName]]').join(contactus.firstName)
            .split('[[LastName]]').join(contactus.lastName).split('[[PhoneNumber]]').join(contactus.phone)
            .split('[[Email]]').join(contactus.email)
              .split('[[RequestFor]]').join(contactus.subject).split('[[MessageContent]]').join(contactus.Notes)
              .split('[[CHP]]').join(this.orgDetails.orgName).split('[[SupportMessage]]').join("Support Team")
              .split('[[CHPPhone]]').join(this.orgDetails.orgPhone).split('[[CHPEmail]]').join(this.orgDetails.orgEmail)
              .split('[[PortalUrl]]').join(location)
              .split('[[CurrentDate]]').join(this.ServerDateTime)
              .split('[[FacebookLink]]').join(this.orgDetails.facebookLink)
              .split('[[LinkedinLink]]').join(this.orgDetails.linkedInLink)
              .split('[[TwitterLink]]').join(this.orgDetails.twitterLink)
              .split('[[InstagramLink]]').join(this.orgDetails.instagramLink)
              .split('[[YoutubeLink]]').join(this.orgDetails.youtubeLink)
              .split('[[portallogo]]').join(this.portallogo)
              .split('[[facebookicon]]').join(this.facebookicon)
              .split('[[linkedinicon]]').join(this.linkedinicon)
              .split('[[twittericon]]').join(this.twittericon)
              .split('[[instagramicon]]').join(this.instagramicon)
              .split('[[youtubeicon]]').join(this.youtubeicon)
              emailNotificationReport.Content = bodycontent;
            this.resultservice.SendEmailNotification(emailNotificationReport).then((result: any) => {

              //this.router.navigate(['']);
            })
          })
          Swal.fire({
            title: 'Thank you',
            text: 'Your request was submitted successfully!',
            icon: 'success'
          }).then((result) => {
            if (result.value) {
              //this.contactusform.reset;
              this.router.navigate(['']);

            }
          });
        }
        else {
          Swal.fire({
            text: 'SomeThink went wrong!',
            icon: 'error'
          })
        }
      });
    }
  }

  btnCancel() {
    this.router.navigate(['']);
  }

  get formControl() {
    return this.contactusform.controls;
  }
}
